// The top of My style: where the strategist is in five steps, and the one thing to do next.

import { nextStepText, stageState, STYLE_STAGES } from '../../lib/styleIntake';
import type { StyleStage } from '../../lib/styleIntake';

export function StyleProgress({ stage }: { stage: StyleStage }) {
  return (
    <div className="styleprogress">
      <ol className="stylesteps">
        {STYLE_STAGES.map((step, index) => (
          <li key={step.key} className={`stylestepdot ${stageState(step.key, stage)}`}>
            <span className="stylestepnum">{stageState(step.key, stage) === 'done' ? '✓' : index + 1}</span>
            {step.label}
          </li>
        ))}
      </ol>
      <p className={stage === 'live' ? 'stylenext done' : 'stylenext'}>{nextStepText(stage)}</p>
    </div>
  );
}
